import { Component, EventEmitter, Output, ViewEncapsulation } from '@angular/core';

@Component({
  standalone: false,
  selector: 'ui-back-button-wrapper',
  templateUrl: './ui-back-button-wrapper.component.html',
  styleUrls: ['./ui-back-button-wrapper.component.scss'],
  encapsulation: ViewEncapsulation.None,
})
export class UiBackButtonWrapperComponent {
  @Output() public onClick = new EventEmitter<void>();
}
